const $lib = require('aes-ecb');

const _s1 = 'Lzow';
const _s2 = 'P00j';
const _s3 = 'OTU3';
const _s4 = 'ZmFD';
const _s5 = 'JSVu';
const _s6 = 'RA==';
const _$ = [_s1, _s2, _s3, _s4, _s5, _s6];
const $gk = () => atob(_$.join(''));

const _k1 = 'NzJl';
const _k2 = 'PzV2';
const _k3 = 'ZSM3';
const _k4 = 'ZmE0';
const _k5 = 'KmV4';
const _k6 = 'aQ==';
const _k$ = [_k1, _k2, _k3, _k4, _k5, _k6];
const $fk = () => atob(_k$.join(''));

const $toBytes = (b64) =>
    new Uint8Array(
        atob(b64)
            .split('')
            .map((ch) => ch.charCodeAt(0))
    );

const $dec1 = async (enc, keyStr) => {
    try {
        const bytes = $toBytes(enc);
        const iv = bytes.slice(0, 12);
        const data = bytes.slice(12);
        const algo = ['AE', 'S-G', 'CM'].join('');
        const opts = { name: algo, tagLength: 128, iv };

        const impKey = await crypto.subtle.importKey(
            'raw',
            new TextEncoder().encode(keyStr),
            algo,
            false,
            ['decrypt']
        );

        const clear = await crypto.subtle.decrypt(opts, impKey, data);
        return new TextDecoder().decode(clear);
    } catch (e) {
        console.log(e, 'primary fail');
        return null;
    }
};

const $dec2 = async (enc) => {
    try {
        return await $lib.decrypt($fk(), enc);
    } catch (e) {
        console.log(e, 'fallback fail');
        return null;
    }
};

export const dc = async (enc) => {
    const kFinal = $gk();
    let result = await $dec1(enc, kFinal);
    if (!result) result = await $dec2(enc);
    return result;
};
